import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import CheckCard from "../../utils/components/CheckCard";

import { searchModule } from "../../utils/Utils";
import { setAlert } from "../../../actions/alertActions";

import "../../../styles/components/evs/modals/AddUsers.scss";

class AddUsers extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      search: "",
      drivers: [],
    };

    this.fetchDriverPool = this.fetchDriverPool.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchDriverPool();
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  fetchDriverPool() {
    axios
      .get("/api/private/drivers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.safeSetState({
          drivers: res.data.poolOfDrivers.map((d) =>
            Object.assign(d, { checked: false })
          ),
        });
      })
      .catch((err) => {
        if (err.response && err.response.data)
          this.props.setAlert(I18n.t(err.response.data.message), "danger");
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  }

  handleCheck(e, id) {
    const idx = this.state.drivers.findIndex((d) => d._id === id);

    if (
      (idx >= 0 && this.props.isAdmin === true) ||
      (idx >= 0 &&
        this.state.drivers.filter((d) => d.checked).length <
          this.props.userPackage?.driversInGroupDriversLimit) ||
      (idx >= 0 && this.state.drivers[idx].checked)
    ) {
      let newDriver = Object.assign({}, this.state.drivers[idx]);
      newDriver.checked = !newDriver.checked;
      this.safeSetState((prevState) => ({
        drivers: [
          ...prevState.drivers.slice(0, idx),
          newDriver,
          ...prevState.drivers.slice(idx + 1),
        ],
      }));
    }
  }

  resetChecks() {
    let reset = this.state.drivers.map((d) => {
      d.checked = false;
      return d;
    });
    this.safeSetState({
      drivers: reset,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="addUsers"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={() => this.resetChecks()}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate value="drivers_addUser" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="search-container">
              <input
                type="text"
                className="search"
                value={this.state.search}
                onChange={(e) => searchModule.setSearch(this, e.target.value)}
              />
            </div>
            <div className="driver-list">
              {this.state.drivers
                .filter((i) => searchModule.filter(this, i))
                .filter(
                  (value) =>
                    this.props.listOfUsers &&
                    this.props.listOfUsers.findIndex((user) =>
                      user.driverId
                        ? user.driverId === value.driverId
                        : user.mobile === value.mobile
                    ) === -1
                )
                .map((d, i) => (
                  <CheckCard
                    key={d._id}
                    type="info"
                    name={d.name || ""}
                    avatar={d.imageContent}
                    info={`${d.internationalPrefix} ${d.mobile}`}
                    checked={d.checked}
                    onChange={(e) => this.handleCheck(e, d._id)}
                  />
                ))}
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            disabled={
              this.state.drivers.findIndex((d) => d.checked) === -1 &&
              this.props.isAdmin === false
            }
            onClick={(e) =>
              this.props.onAdd(
                e,
                this.state.drivers.filter((d) => d.checked)
              )
            }
          >
            <Translate value="drivers_add" />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(AddUsers);
